import React from "react";
import { Chip, Tooltip } from "@mui/material";

/**
 * AuditStatusChip
 * Chip de estado con color dinámico proveniente de la DB.
 *
 * Props:
 *   codigo      {string}  — ej: "EN_INVESTIGACION"
 *   descripcion {string}  — ej: "En investigación"
 *   color       {string}  — hex proveniente de audit_item_status.color
 *   size        {string}  — "small" | "medium"  (default "small")
 *   tooltip     {boolean} — muestra el código en tooltip (default false)
 */
export default function AuditStatusChip({
    codigo,
    descripcion,
    color = "#90caf9",
    size = "small",
    tooltip = false,
}) {
    // Calcular color de texto según luminosidad del fondo
    const textColor = getContrastColor(color);

    const chip = (
        <Chip
            label={descripcion || codigo}
            size={size}
            sx={{
                backgroundColor: color,
                color: textColor,
                fontWeight: 600,
                fontSize: size === "small" ? "0.72rem" : "0.8rem",
                letterSpacing: "0.02em",
                border: "none",
                "& .MuiChip-label": { px: 1.2 },
            }}
        />
    );

    if (tooltip && codigo) {
        return <Tooltip title={codigo} arrow>{chip}</Tooltip>;
    }

    return chip;
}

// ── Helper: contraste automático blanco/negro ─────────────────
function getContrastColor(hex) {
    try {
        const clean = hex.replace("#", "");
        const r = parseInt(clean.substring(0, 2), 16);
        const g = parseInt(clean.substring(2, 4), 16);
        const b = parseInt(clean.substring(4, 6), 16);
        // Fórmula luminosidad relativa (WCAG)
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance > 0.55 ? "#1a1a1a" : "#ffffff";
    } catch {
        return "#1a1a1a";
    }
}